import { Component, Input, OnInit } from '@angular/core';
import { XROUTES } from 'src/app/shared/config';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-layout-main-2026',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.styl'],
})
export class LayoutMain2026Component implements OnInit {
  @Input() navi = 0;

  S_ROOT_URL = environment.S_ROOT_URL;

  navs = [
    XROUTES[2026].index,
    XROUTES[2026].onlineexhibition,
    XROUTES[2026].onlinemap,
    XROUTES[2026].ychat,
    null, // XROUTES[2026].yshop, // 注释掉云商城
    XROUTES[2026].lookguide,
    XROUTES[2026].news,
    XROUTES[2026].report,
    XROUTES[2026].reservation,
    XROUTES[2026].previous,
  ];

  footernavs = [
    [
      XROUTES[2026].onlineexhibition,
      XROUTES[2026].previous,
      XROUTES[2026].report,
    ],
    [
      XROUTES[2026].onlinemap,
      XROUTES[2026].lookguide,
      XROUTES[2026].reservation,
    ],
    [XROUTES[2026].ychat, XROUTES[2026].news],
  ];

  email = 'shjiaobohui@163.com';

  constructor() {}

  ngOnInit() {}
}
